export default "__VITE_ASSET__c5676643__"